'use strict';
const angular = require('angular');
const {equals, isUndefined} = angular;

var template = require('./response.html');

module.exports.directive = [
  FormResponseDirective];

module.exports.controller = [
  '$scope',
  '$attrs',
  '$log',
  '$timeout',
  'FormResponseDomain',
  FormResponseController];

function FormResponseDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      api: '=?responseApi',
      response: '=',
      form: '=?'
    },
    controllerAs: 'formResponse',
    bindToController: true,
    controller: 'FormResponseController'
  }
}

function FormResponseController($scope, $attrs, $log, $timeout, FormResponseDomain) {
  var vm = this;
  var newResponse = false;
  var currentFormId;
  var currentResponseId;
  vm.api = vm.api || {};
  vm.fieldApis = {};
  vm.fields = []; // initialize now to simplify certain checks like getMode

  // Define API
  vm.api.createResponse = createResponse;
  vm.api.setForm = setForm;
  vm.api.setResponse = setResponse;
  vm.api.isEditMode = isEditMode;
  vm.api.getMode = getMode;
  vm.api.setMode = setMode;
  vm.api.isDirty = isDirty;
  vm.api.save = save;
  vm.api.revert = revert;

  initForm();

  function initForm() {
    if ($attrs.createFormResponse === 'true') {
      $scope.$watch(function () {
        return vm.form && vm.form.$id;
      }, function (id) {
        if (id && (id !== currentFormId)) {
          setForm(vm.form);
        }
      });
    } else {
      $scope.$watch(function () {
        return vm.response && vm.response.$id;
      }, function (id) {
        if (id && (id !== currentResponseId)) {
          setResponse(vm.response);
        }
      });
    }
  }

  function setForm(formData) {
    if (!formData) {
      vm.form = null;
      vm.fields = [];
    } else if (!vm.form || (vm.form.$id !== formData.$id)) {
      vm.form = formData;
      currentFormId = vm.form.$id;
      createResponse();
    }
  }

  function setResponse(formResponse) {
    if (!formResponse) {
      newResponse = false;
      vm.response = null;
    } else if (formResponse && formResponse.$id && (formResponse.$id !== currentResponseId)) {
      newResponse = !formResponse.$isPersisted();
      vm.response = formResponse;
      currentResponseId = formResponse.$id;
      getResponseFields(formResponse);
    }
  }

  function getResponseFields(formResponse) {
    var responseId = vm.response.$id;
    return formResponse.getFields().then(function (mergedFields) {
      if (currentResponseId !== responseId) return;

      if (mergedFields && mergedFields.formVersion && mergedFields.formVersion !== vm.response.formVersion)
        vm.response.formVersion = mergedFields.formVersion;
      vm.fields = mergedFields || []; // if this is falsey, this is an invalid blank form
    });
  }


  /*****************************************************************************************************************
   * Database methods
   ****************************************************************************************************************/

  function isDirty() {
    return vm.response && (vm.response.$isDirty() || areFieldsDirty());
  }

  function save() {
    if (!vm.response || (!vm.response.$isDirty() && !areFieldsDirty())) {
      $log.debug('no changes detected, cancelling save');
      return Promise.resolve(null);
    }

    vm.response.fields = extractResponses(vm.fields);

    if (!validateForm()) {
      // need to inform user
      console.warn('errors, canceling save');
      return Promise.reject('errors, canceling save');
    }

    // TODO: handle errors. inform user appropriately
    if (newResponse) {
      return FormResponseDomain.createResponse(vm.response).then(setResponse).catch(logError);
    } else {
      return FormResponseDomain.updateResponse(vm.response).catch(logError);
    }
  }

  function logError(error) {
    console.error(error);
    return Promise.reject(error);
  }

  function extractResponses(fields) {
    var list = [];
    for (var i = 0, length = fields.length; i < length; i++) {
      if (vm.fields[i].response) {
        list.push(vm.fields[i].response);
      }
    }
    return list;
  }

  function validateForm() {
    var formIsValid = true;
    var field;
    var fieldErrors = [];
    var newLen;

    vm.response.$validate();

    if (vm.response.$hasErrors()) {
      console.warn(vm.response.$errors);
      formIsValid = false;
    }

    for (var i = 0, length = vm.fields.length; i < length; i++) {
      field = vm.fields[i];
      if (field.field.legacy && !field.response) {
        // response does not have this legacy field, skip it
      } else {
        newLen = fieldErrors.push(FormResponseDomain.validateFieldResult(field.response, field.field, []));

        if (fieldErrors[newLen - 1].length) {
          console.warn(fieldErrors[newLen - 1]);
          formIsValid = false;
        }
      }
    }

    return formIsValid;
  }

  // we could store the clean fields as json, and upon reversion, replace vm.fields with the parsed json again
  // reset the local field data array to the database version
  // TODO: currently not offline friendly
  function revert() {
    if (newResponse) {
      return createResponse();
    } else if (vm.response) {
      return getResponseFields(vm.response);
    }
  }

  function areFieldsDirty() {
    if (!vm.response || !vm.fields) {
      return false;
    } else {
      var originalFields = vm.response.$getOriginalValue('fields');

      if (!originalFields || originalFields.length !== vm.fields.length) {
        return true;
      } else {
        for (var i = 0, length = originalFields.length; i < length; i++) {
          if (!equals(originalFields[i], vm.fields[i] ? vm.fields[i].response : null))
            return true;
        }
        return false;
      }
    }
  }


  /*****************************************************************************************************************
   * New Response
   ****************************************************************************************************************/

  // TODO: cancel and report error to user if the form does not have a current version
  function createResponse() {
    newResponse = true;
    vm.response = FormResponseDomain.$factory.create();
    vm.response.form = vm.form.$id;
    vm.response.formVersion = vm.form.currentVersion;
    currentResponseId = vm.response.$id;

    var formId = vm.form.$id;

    return vm.form.getCurrentVersion().then(function (version) {
      if (currentFormId !== formId) return;
      createResponseFields(version ? version.fields : []);
    });
  }

  function createResponseFields(list) {
    var length = list.length;
    vm.fields = new Array(length);
    for (var i = 0; i < length; i++) {
      vm.fields[i] = {
        id: list[i].id,
        field: list[i],
        response: FormResponseDomain.createFromFormField(list[i])
      };
      setFieldMode(list[i], 'response-view');
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function isEditMode() {
    return getMode() === 'response-edit';
  }

  function getMode() {
    for (var i = 0, length = vm.fields.length; i < length; i++) {
      if (vm.fields[i] && vm.fieldApis[vm.fields[i].id]) {
        return vm.fieldApis[vm.fields[i].id].getMode();
      }
    }
    return 'response-view';
  }

  function setMode(mode) {
    //TODO: validate mode
    var i = vm.fields.length;
    while (i--) {
      setFieldMode(vm.fields[i], mode);
    }
  }

  function setFieldMode(field, mode, retry) {
    if (field.response && field.response.legacy) {
      return;
    }
    if (isUndefined(retry)) retry = 0;
    if (vm.fieldApis[field.id]) {
      vm.fieldApis[field.id].setMode(mode);
    } else if (retry < 5) {
      $timeout(setFieldMode.bind(null, field, mode, ++retry), 20);
    } else {
      console.warn('failed to autoset mode');
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/forms/directives/response/FormResponseDirective.js